
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop} from 'vue-property-decorator';

  @Component({})
  export default class DeleteButton extends Vue {
    @Prop({required: false, default: false}) loading!: boolean;
    @Prop({required: false, default: false}) disabled!: boolean;
    @Prop({required: false, default: 'buttons.delete'}) label!: string;
    @Prop({required: false, default: 'far fa-trash-alt'}) icon!: string;

    @Emit()
    onClick() {
      return;
    }
  }
